import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { RouteParamsTypes, Modules, NonAuthRoutes } from '../enums';
import ProtectedRoute from '../components/ProtectedRoute';
import TenantList from '../modules/tenants/list';
import TenantForm from '../modules/tenants/form';
import TenantDetail from '../modules/tenants/detail';

const Tenants: React.FC = () => {
  return (
    <Routes>
      <Route path={RouteParamsTypes.blank} element={<ProtectedRoute component={TenantList} />} />
      <Route path={RouteParamsTypes.add} element={<ProtectedRoute component={TenantForm} />} />
      <Route path={RouteParamsTypes.edit + RouteParamsTypes.id} element={<ProtectedRoute component={TenantForm} />} />
      <Route path={RouteParamsTypes.id} element={<ProtectedRoute component={TenantDetail} />} />
      <Route
        path={RouteParamsTypes.any}
        element={<Navigate replace to={{ pathname: Modules.error + NonAuthRoutes.notFound }} />}
      />
    </Routes>
  );
};

export default Tenants;
